import shortid from "shortid"
import seedrandom from "seedrandom"
import querystring from "query-string"

import Dev from "@frog/source/utility/Dev.js"

const query = querystring.parse(window.location.search)
const seed = query.seed || shortid.generate()

seedrandom(seed, {"global": true})

if(Dev.isEnabled) {
    const url = window.location.origin + (window.location.path || "") + "?seed=" + seed
    console.info("%cRandom: To maintain your random seed, go to " + url, "color: green")
}

import shuffle from "lodash.shuffle"

export default class Random {
    static sign() {
        return Math.random() < 0.5 ? -1 : +1
    }
    static range(a, b) {
        const min = Math.min(a, b)
        const max = Math.max(a, b)
        return min + (Math.random() * (max - min))
    }
    static element(array) {
        return array[Math.floor(Math.random() * array.length)]
    }
    static shuffle(array) {
        return shuffle(array) // lol
        // const superarray = []
        // for(let i = array.length - 1; i > 0; i -= 1) {
        //     let j = Math.floor(Math.random() * (i + 1))
        //     superarray[j] = array[i]
        //     // let temp = array[i]
        //     // array[i] = array[j]
        //     // array[j] = temp
        // }
        // return superarray
    }
}
